import React, { useContext } from 'react';
import { UserContext } from 'Vendor/Context/UserContextProvider';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip, { TooltipProps } from 'react-bootstrap/Tooltip';

interface UtilisationData {
    count: number;
    id: number;
    icon: string;
    name: {
        [key: string]: string
    };
}

interface UtilisationProps {
    data: UtilisationData[];
}

const Utilisation: React.FC<UtilisationProps> = ({ data }) => {
    const {currentUser} = useContext(UserContext);

    const renderTooltip = (props: TooltipProps, item: UtilisationData) => (
        <Tooltip id={`tooltip-${item.id}`} {...props}>
            {currentUser?.currentOrganization?.defaultLanguage && item.name[currentUser?.currentOrganization?.defaultLanguage]}: {item.count}
        </Tooltip>
    );

    return (
        <div className="utilisation-container container py-2">
            <div className="icons d-flex justify-content-center align-items-center gap-1 flex-wrap fs-6">
                {Array.isArray(data) && data?.map(item =>
                    item.count >= 1 ? (
                        <div key={item.id} className="position-relative">
                            <OverlayTrigger
                                placement="top"
                                delay={{ show: 50, hide: 50 }}
                                overlay={(props) => renderTooltip(props, item)}
                            >
                                <i className={`${item.icon} fs-5`} />
                            </OverlayTrigger>
                        </div>
                    ) : null
                )}
            </div>
        </div>
    );
};

export default Utilisation;
